<div class="measurement-tool-list">
  <div
    class="measurement-tool-item"
    #measurementToolEl
    *ngFor="let item of measurementToolList"
  >
    <app-button
      class="btn-tool"
      [buttonType]="
        item.hover || isMeasurementToolItemActive(item) ? 'primary' : 'normal'
      "
      [styleType]="isMeasurementToolItemActive(item) ? 'contained' : 'text'"
      shapeType="circle"
      sizeType="large"
      [icon]="item.icon"
      (click)="onMeasurementToolClick($event, item)"
      (mouseover)="item.hover = true"
      (mouseleave)="item.hover = false"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    ></app-button>

    <app-tooltip
      [target]="measurementToolEl"
      verticalAlignment="top"
      horizontalAlignment="center"
    >
  {{ item.text }}
    </app-tooltip>
  </div>
</div>

<div class="controls">
  <div class="unit-input-container">
    <app-select-box
      class="input"
      [items]="unitList"
      [value]="unitType"
      (valueChange)="onUnitChange($event)"
      displayExpr="text"
      valueExpr="value"
      [disabled]="isUnitSelectDisabled"
      [showClearButton]="false"
      [showErrorEnabled]="false"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    ></app-select-box>
  </div>

  <app-button
    class="btn-clear"
    buttonType="primary"
    styleType="contained"
    sizeType="small"
  [text]="translationService.getCurrentLanguage()['clear']"
    (click)="onBtnClearClick($event)"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-button>
</div>
